var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i-badge',{staticClass:"signal-chip",attrs:{"colour":_vm.iBadgeColours.ERROR,"icon":"small-alert-triangle","has-leading-icon":true,"label":_vm.title,"interactable":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }